import useGetUser from "api/queries/useGetUser";
import {
	bubblesUrl,
	chimesUrl,
	sonarUrl,
	woodBlocksUrl,
} from "common/soundDefinitions";
import { useEffect, useMemo } from "react";

interface Args {
	enabled: boolean;
	newAlertCount: number;
}

const bubblesAudio = new Audio(bubblesUrl);
const chimesAudio = new Audio(chimesUrl);
const sonarAudio = new Audio(sonarUrl);
const woodBlocksAudio = new Audio(woodBlocksUrl);

const useNewAlertSound = ({ enabled, newAlertCount }: Args) => {
	const { data: user } = useGetUser();

	const audio = useMemo(() => {
		switch (user?.preferences.notification_sound) {
			case "bubbles":
				return bubblesAudio;

			case "chimes":
				return chimesAudio;

			case "sonar":
				return sonarAudio;

			case "wood_blocks":
				return woodBlocksAudio;

			default:
				return bubblesAudio;
		}
	}, [user?.preferences.notification_sound]);

	/** when newAlertCount changes and enabled, play the sound */
	useEffect(() => {
		if (!enabled || newAlertCount === 0) return;

		audio.play().catch(() => {
			// Empty catch block to suppress the error
		});
	}, [enabled, newAlertCount, audio]);
};

export default useNewAlertSound;
